module.exports = __webpack_public_path__ + "img/homepage-quick-links-default.eb8e0470.jpg";